import { Pipe, PipeTransform } from '@angular/core';

declare function isEASite(): boolean;

@Pipe({
    name: 'redirectfilter'
})
export class HostRedirectPipe implements PipeTransform {

    transform(value: string): string {
        const host = window.location.hostname;
        const dev = 'https://dev.equitable.com/';
        const prod = 'https://www.equitable.com/';


        if (host.indexOf('int') !== -1 || host.indexOf('dev') !== -1) {
            if (isEASite()) {
                if (value === 'support')
                    value = "https://int.equitableadvisors.com/customer-service";
                else
                    value = "https://int.equitableadvisors.com/";
            } else {
                value = dev + value;
            }


        } else {
            if (isEASite()) {
                if (value === 'support')
                    value = "https://equitableadvisors.com/customer-service";
                else
                    value = "https://equitableadvisors.com/";
            } else {
                value = prod + value;
            }
        }


        return value;
    }
}